import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Users, Stethoscope, Activity, Package } from 'lucide-react';

const ADMIN_TABS = [
  { to: '/administration/management-staff', label: 'Management Staff', icon: <Users       size={17} /> },
  { to: '/administration/physio',           label: 'Physiotherapists', icon: <Stethoscope size={17} /> },
];

const MED_EQUIP_TABS = [
  { to: '/administration/medical-devices',  label: 'Medical Devices',  icon: <Activity    size={17} /> },
  { to: '/administration/consumables',      label: 'Consumables',      icon: <Package     size={17} /> },
];

const MED_EQUIP_PATHS = ['/administration/medical-devices', '/administration/consumables'];

const AdministrationLayout: React.FC = () => {
  const { pathname } = useLocation();
  const isConsumables    = pathname.startsWith('/administration/consumables');
  const isMedicalDevices = pathname.startsWith('/administration/medical-devices');
  const isMedEquip       = MED_EQUIP_PATHS.some((p) => pathname.startsWith(p));

  const title    = isConsumables ? 'Consumables' : isMedicalDevices ? 'Medical Devices' : 'Administration';
  const subtitle = isConsumables ? 'Manage consumable stock, batches, and inventory.' : isMedicalDevices ? 'Manage physical medical device assets.' : 'Manage staff access and specialists.';
  const tabs     = isMedEquip ? MED_EQUIP_TABS : ADMIN_TABS;

  const tabStyle = ({ isActive }: { isActive: boolean }): React.CSSProperties => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.45rem',
    padding: '0.875rem 1.5rem',
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: isActive ? '3px solid #2563eb' : '3px solid transparent',
    marginBottom: '-2px',
    color: isActive ? '#2563eb' : '#64748b',
    fontWeight: 700,
    fontSize: '0.95rem',
    cursor: 'pointer',
    transition: 'color 0.15s',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
  });

  return (
    <div style={{ padding: '1.5rem 2rem', backgroundColor: '#f8fafc', minHeight: '100vh' }}>

      {/* ── Header ── */}
      <div style={{ marginBottom: '1.25rem' }}>
        <h1 style={{ fontSize: '1.875rem', fontWeight: 800, color: '#1e293b', margin: 0 }}>
          {title}
        </h1>
        <p style={{ color: '#64748b', margin: '0.25rem 0 0' }}>
          {subtitle}
        </p>
      </div>

      {/* ── Tab Bar — Administration only; Medical Equipment switches from the sidebar ── */}
      {!isMedEquip && (
        <div style={{ display: 'flex', borderBottom: '2px solid #e2e8f0', marginBottom: '1.5rem' }}>
          {tabs.map(({ to, label, icon }) => (
            <NavLink key={to} to={to} style={tabStyle}>
              {icon}
              {label}
            </NavLink>
          ))}
        </div>
      )}

      {/* ── Content Card ── */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '0.75rem',
        padding: '1.25rem',
        boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
      }}>
        <Outlet />
      </div>

    </div>
  );
};

export default AdministrationLayout;
